import { render, staticRenderFns } from "./CompraDividaForm.vue?vue&type=template&id=c2171898&scoped=true&"
import script from "./CompraDividaForm.vue?vue&type=script&lang=js&"
export * from "./CompraDividaForm.vue?vue&type=script&lang=js&"
import style0 from "./CompraDividaForm.vue?vue&type=style&index=0&id=c2171898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2171898",
  null
  
)

export default component.exports